import {useQuery} from '@tanstack/react-query'
import {useGetProductsApiMethod} from 'api/useGetProductsApiMethod'

export const useGetProductsQuery = (productIds: string[]) => {
  const getProducts = useGetProductsApiMethod()

  return useQuery({
    queryKey: ['getProducts', productIds],
    queryFn: () => getProducts(productIds),
  })
}
